export const COURT_BMC_LABEL = 'Court: Boston Municipal';
export const COURT_DISTRICT_LABEL = 'Court: District';
export const COURT_HOUSING_LABEL = 'Court: Housing';
export const COURT_JUVENILE_LABEL = 'Court: Juvenile';
export const COURT_LAND_LABEL = 'Court: Land';
export const COURT_PROBATE_FAMILY_LABEL = 'Court: Probate/Family';
export const COURT_SUPERIOR_LABEL = 'Court: Superior';

export const COURT_DISTRICT_ID = '507f1f77bcf86cd799439017';
export const COURT_BMC_ID = '507f1f77bcf86cd799439016';
export const COURT_JUVENILE_ID = '507f1f77bcf86cd799439019';
export const COURT_PROBATE_FAMILY_ID = '507f1f77bcf86cd799439021';

export const CONFLICT_RESOLUTION_ID = '65f062bc2d71dfb4e188033e';
export const CR_MEDIATION = '65f062bc2d71dfb4e188009e';
export const CR_CONCILIATION = '65f062bc2d71dfb4e188010e';

export const COURT_CASES_LABELS = [
    COURT_BMC_LABEL,
    COURT_DISTRICT_LABEL,
    COURT_HOUSING_LABEL,
    COURT_JUVENILE_LABEL,
    COURT_LAND_LABEL,
    COURT_PROBATE_FAMILY_LABEL,
    COURT_SUPERIOR_LABEL,
];

export const UNKNOWN = {label: 'Unknown', _id: '507f1f77bcf86cd799439011'};
export const OTHER = {label: 'Other', _id: '507f1f77bcf86cd799439012'};

export const SOCIALMEDIA_MEDIA_COVERAGE = {
    label: 'Social Media/Media Coverage',
    _id: '507f1f77bcf86cd799439013',
    description: 'Social media platform, press coverage',
};
// export const COWORKER = {
//     label: 'Co-worker',
//     _id: '507f1f77bcf86cd799439014',
// };

// export const FAMILYMEMBER = {
//     label: 'Family member',
//     _id: '507f1f77bcf86cd799439023',
// };
export const FORMER_CLIENT = {
    label: 'Former Client',
    _id: '507f1f77bcf86cd799439024',
    description: 'Client who has received services in the past',
};

export const HEALTHCARE_PROVIDER = {
    label: 'Healthcare Provider',
    _id: '507f1f77bcf86cd799439124',
    description: 'Physical or mental health service provider',
};

// export const FRIEND = {
//     label: 'Friend',
//     _id: '507f1f77bcf86cd799439025',
// };
export const HIGHER_EDU_ORG = {
    label: 'Higher Education Organization',
    _id: '507f1f77bcf86cd799439026',
    description: 'College or university',
};
export const HOUSING_AGENCY = {
    label: 'Housing Agency',
    _id: '507f1f77bcf86cd799438027',
    description: 'Housing authority, RAA, HCEC',
};

export const LAW_FIRM_ATTORNEY = {
    label: 'Law Firm/Attorney',
    _id: '507f1f77bcf86cd799437027',
    description: 'Private law firm and/or attorneys',
};

export const LEGAL_AID_ORG = {
    label: 'Legal Aid Organization',
    _id: '507f1f77bcf86cd799439027',
    description: 'Legal services organization, excludes private law firms',
};

export const LOCAL_ORG = {
    label: 'Local Organization',
    _id: '507f1f77bcf86cd799439028',
    description: 'Non-profit organization, club, association, group',
};

export const LOCAL_BUSINESS = {
    label: 'Local Business',
    _id: '507f1f77bcf86cd799439029',
    description: 'For-profit organization',
};

export const LOCAL_GOVERNMENT = {
    label: 'Local Government',
    _id: '507f1f77bcf86cd799439030',
    description: 'Municipality',
};
// export const MEDIATION_ADRNETWORK = {
//     label: 'Mediation/ADR network',
//     _id: '507f1f77bcf86cd799439031',
// };
export const POLICE_DEPT = {
    label: 'Police Department',
    _id: '507f1f77bcf86cd799439032',
    description: 'Law enforcement',
};
export const RELIGIOUS_ORG = {
    label: 'Religious Organization',
    _id: '507f1f77bcf86cd799439033',
    description: 'Faith-based organization',
};
export const SCHOOL = {
    label: 'School',
    _id: '507f1f77bcf86cd799439034',
    description: 'Grades K-12',
};
export const STATE_GOVERNMENT = {
    label: 'State Government',
    _id: '507f1f77bcf86cd799439035',
    description: 'Agency or office run by the State',
};
// export const THERAPIST = {
//     label: 'Therapist',
//     _id: '507f1f77bcf86cd799439036',
// };
export const WEBSITE = {
    label: 'Website',
    _id: '507f1f77bcf86cd799439037',
    description: 'CMC website, online search, resolutionma.org',
};
export const WORD_OF_MOUTH = {
    label: 'Word of Mouth',
    _id: '507f1f77bcf86cd799439038',
    description: 'Friend/Family member/Co-worker',
};
// export const ATTORNEY = {
//     label: 'Attorney',
//     _id: '507f1f77bcf86cd799439039',
// };
export const MEDIATION_DR_NETOWORK = {
    label: 'Mediation/DR Network',
    _id: '507f1f77bcf86cd799439040',
    description: 'Network of dispute resolution providers',
};

export const CORRECTIONALFACILITY = {
    label: 'Correctional Facility',
    _id: '507f1f77bcf86cd799439015',
    description: 'MA Department of Corrections or Sheriff facility',
};

// COURT_CASES
export const COURT_BMC = {
    label: COURT_BMC_LABEL,
    _id: COURT_BMC_ID,
};
export const COURT_DISTRICT = {
    label: COURT_DISTRICT_LABEL,
    _id: '507f1f77bcf86cd799439017',
    description: 'Trial court with limited jurisdiction in MA',
};
export const COURT_HOUSING = {label: COURT_HOUSING_LABEL, _id: '507f1f77bcf86cd799439018'};
export const COURT_JUVENILE = {label: COURT_JUVENILE_LABEL, _id: '507f1f77bcf86cd799439019'};
export const COURT_LAND = {label: COURT_LAND_LABEL, _id: '507f1f77bcf86cd799439020'};
export const COURT_PROBATE_FAMILY = {label: COURT_PROBATE_FAMILY_LABEL, _id: '507f1f77bcf86cd799439021'};
export const COURT_SUPERIOR = {
    label: COURT_SUPERIOR_LABEL,
    _id: '507f1f77bcf86cd799439022',
    description: 'Trial court with general jurisdiction in MA',
};

export const ENTITY_TYPES = {
    value: [
        CORRECTIONALFACILITY,
        COURT_BMC,
        COURT_DISTRICT,
        COURT_HOUSING,
        COURT_JUVENILE,
        COURT_LAND,
        COURT_PROBATE_FAMILY,
        COURT_SUPERIOR,

        FORMER_CLIENT,
        HEALTHCARE_PROVIDER,
        HIGHER_EDU_ORG,
        HOUSING_AGENCY,
        LAW_FIRM_ATTORNEY,
        LEGAL_AID_ORG,
        LOCAL_BUSINESS,
        LOCAL_GOVERNMENT,
        LOCAL_ORG,

        MEDIATION_DR_NETOWORK,
        POLICE_DEPT,
        RELIGIOUS_ORG,
        SCHOOL,
        SOCIALMEDIA_MEDIA_COVERAGE,
        STATE_GOVERNMENT,
        WEBSITE,
        WORD_OF_MOUTH,
        UNKNOWN,
        OTHER,
    ].map(d => ({...d, active: true})),
};
